/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { reposDelete } from "../../funcs/reposDelete.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteRepoRequest$inboundSchema,
};

export const tool$reposDelete: ToolDefinition<typeof args> = {
  name: "repos-delete",
  description: `Delete a repository

Removes a repository; org owner/admin only. The DB delete is
authoritative; the Gitea teardown is best-effort cleanup.
`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await reposDelete(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(void 0, apiCall);
  },
};
